export enum GridSettingType {
    StandardLoanTable = 1,
    PrincipalUsersTable = 2,
    BrokerUsersTable = 3,
    MasterNotesTable = 4,
    SubNotesTable = 5,
    RecycleBinTable = 6,
    LoanInsuranceTable = 7,
    LoanInsuranceTable_MasterNotes_OutstandingMissing = 8,
    LoanInsuranceTable_MasterNotes_OutstandingGood = 9,
    LoanInsuranceTable_MasterNotes_ClosedMissing = 10,
    LoanInsuranceTable_MasterNotes_ClosedGood = 11,
    LoanInsuranceTable_MasterNotes_Repaid = 12,
    LoanInsuranceTable_MasterNotes_Recycle = 13,
    LoanInsuranceTable_SubNotes_OutstandingMissing = 14,
    LoanInsuranceTable_SubNotes_OutstandingGood = 15,
    LoanInsuranceTable_SubNotes_ClosedMissing = 16,
    LoanInsuranceTable_SubNotes_ClosedGood = 17,
    LoanInsuranceTable_SubNotes_Repaid = 18,
    LoanInsuranceTable_SubNotes_Recycle = 19,
    LoanInsuranceTable_Construction_OutstandingMissing = 20,
    LoanInsuranceTable_Construction_OutstandingGood = 21,
    LoanInsuranceTable_Construction_ClosedMissing = 22,
    LoanInsuranceTable_Construction_ClosedGood = 23,
    LoanInsuranceTable_Construction_Repaid = 24,
    LoanInsuranceTable_Construction_Recycle = 25,
    LoanInsuranceTable_Rental_OutstandingMissing = 26,
    LoanInsuranceTable_Rental_OutstandingGood = 27,
    LoanInsuranceTable_Rental_ClosedMissing = 28,
    LoanInsuranceTable_Rental_ClosedGood = 29,
    LoanInsuranceTable_Rental_Repaid = 30,
    LoanInsuranceTable_Rental_Recycle = 31,
    LoanInsuranceTable_BuildRent_OutstandingMissing = 32,
    LoanInsuranceTable_BuildRent_OutstandingGood = 33,
    LoanInsuranceTable_BuildRent_ClosedMissing = 34,
    LoanInsuranceTable_BuildRent_ClosedGood = 35,
    LoanInsuranceTable_BuildRent_Repaid = 36,
    LoanInsuranceTable_BuildRent_Recycle = 37,
    LoanInsuranceTable_FixFlip_OutstandingMissing = 38,
    LoanInsuranceTable_FixFlip_OutstandingGood = 39,
    LoanInsuranceTable_FixFlip_ClosedMissing = 40,
    LoanInsuranceTable_FixFlip_ClosedGood = 41,
    LoanInsuranceTable_FixFlip_Repaid = 42,
    LoanInsuranceTable_FixFlip_Recycle = 43,
    LoanInsuranceTable_Land_OutstandingMissing = 44,
    LoanInsuranceTable_Land_OutstandingGood = 45,
    LoanInsuranceTable_Land_ClosedMissing = 46,
    LoanInsuranceTable_Land_ClosedGood = 47,
    LoanInsuranceTable_Land_Repaid = 48,
    LoanInsuranceTable_Land_Recycle = 49,
    LoanInsuranceTable_Model_OutstandingMissing = 50,
    LoanInsuranceTable_Model_OutstandingGood = 51,
    LoanInsuranceTable_Model_ClosedMissing = 52,
    LoanInsuranceTable_Model_ClosedGood = 53,
    LoanInsuranceTable_Model_Repaid = 54,
    LoanInsuranceTable_Model_Recycle = 55,
    StandardLoanTable_Outstanding_BuildRent = 56,
    StandardLoanTable_Outstanding_Construction = 57,
    StandardLoanTable_Outstanding_FixFlip = 58,
    StandardLoanTable_Outstanding_Land = 59,
    StandardLoanTable_Outstanding_Model = 60,
    StandardLoanTable_Outstanding_Rental = 61,
    Application_SubmittedTable_NonRental = 62,
    Application_SubmittedTable_Rental = 63,
    RecycleBinTable_Declined = 64,
    NoFurtherActionTable = 65,
    ApprovedTable = 67,
    ReviewedTable = 68,
    BfiToOrderTable = 69,
    OrderedTable = 70,
    ReceivedTable = 71,
    LoanSearchTable = 72,
    LinkLoanTable = 73,
    AdminUsersTable = 74,
    PropertyRollupTable = 75,
    PropertyRepaymentsTable = 76,
    PortfolioTable = 77,
    MasterNotesTable_Outstanding = 78,
    SubNotesTable_Outstanding = 79,
    StandardLoanTable_Approved_BuildRent = 80,
    StandardLoanTable_Approved_Construction = 81,
    StandardLoanTable_Approved_FixFlip = 82,
    StandardLoanTable_Approved_Land = 83,
    StandardLoanTable_Approved_Model = 84,
    StandardLoanTable_Approved_Rental = 85,
    MasterNotesTable_Approved = 86,
    SubNotesTable_Approved = 87,
    StandardLoanTable_Lost_BuildRent = 88,
    StandardLoanTable_Lost_Construction = 89,
    StandardLoanTable_Lost_FixFlip = 90,
    StandardLoanTable_Lost_Land = 91,
    StandardLoanTable_Lost_Model = 92,
    StandardLoanTable_Lost_Rental = 93,
    MasterNotesTable_Lost = 94,
    SubNotesTable_Lost = 95,
    StandardLoanTable_Repaid_BuildRent = 96,
    StandardLoanTable_Repaid_Construction = 97,
    StandardLoanTable_Repaid_FixFlip = 98,
    StandardLoanTable_Repaid_Land = 99,
    StandardLoanTable_Repaid_Model = 100,
    StandardLoanTable_Repaid_Rental = 101,
    MasterNotesTable_Repaid = 102,
    SubNotesTable_Repaid = 103,
    HMDA = 104,
    BorrowerEntities = 105,
    BorrowerCrincipals = 106,
    ApplicationReviewers = 107,
    Application_SubmittedTable_LOC = 108,
    BorrowerCompanies = 109,
    Templates = 110,
    Borrower = 111,
    Application_IncompleteFile = 112,
    Appraisers = 113,
    Applications_Incomplete = 114,
    Notices = 115,
    ExperienceTwentyPercentOwnerResidentialRules = 116,
    ExperienceTwentyPercentOwnerCommercialRules = 117,
    ExperienceLicensedGCRules = 118,
    ExperienceLevels = 119,
    PrincipalApplications = 120,
    PrincipalBClients = 121,
    EntityLoans = 122,
    ExperienceSupplementalRules = 123,
    BrokerClientsTable = 124,
    BrokerStatusHistory = 125,
    ExperiencesNonBfiTable = 126,
    ExperiencesBfiRepaidTable = 127,
    ExperiencesBfiOutstandingTable = 128,
    ExperiencesBfiLevelReferenceTable = 129,
    Experiences20PercentOwnerTotalsTable = 130,
    ExperiencesNot20PercentOwnerTotalsTable = 131,
    ExperienceGrandTotalsTable = 132,
    WatchlistSearch = 133,
    UserAgreementsTable = 134,
    PaymentTable = 135,
    GeneralContractorUsersTable = 136,
    Application_SubmittedTable_Bridge = 137,
    StandardLoanTable_Approved_Bridge = 138,
    StandardLoanTable_Lost_Bridge = 139,
    StandardLoanTable_Repaid_Bridge = 140,
    StandardLoanTable_Outstanding_Bridge = 141,
    LoanInsuranceTable_Bridge_OutstandingMissing = 142,
    LoanInsuranceTable_Bridge_OutstandingGood = 143,
    LoanInsuranceTable_Bridge_ClosedMissing = 144,
    LoanInsuranceTable_Bridge_ClosedGood = 145,
    LoanInsuranceTable_Bridge_Repaid = 146,
    LoanInsuranceTable_Bridge_Recycle = 147,
}
